import { render } from "./OurAims.vue?vue&type=template&id=7abb0836&scoped=true"
import script from "./OurAims.vue?vue&type=script&lang=js"
export * from "./OurAims.vue?vue&type=script&lang=js"

import "./OurAims.vue?vue&type=style&index=0&id=7abb0836&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abb0836"]])

export default __exports__